import React from 'react';
import { Link } from '@tanstack/react-router';
import type { TradeDetailSearch } from '../trade-detail-search';

// LR-577 (feedback #69): the Trade ID cell for the History drill-downs (the MTM run's marked
// instruments and the cash-pool posting's contributing trades). Same SPA link as the blotter's ID
// column in trades-columns.tsx — `origin` is stamped on the search so TradeHeader's back control
// returns to the surface the trade was opened from (LR-478).

export interface TradeIdLinkProps {
  /** The position PK — the `$tradeId` route param. Both contracts declare it non-null, but the repo
   *  breakdown arrives from an unvalidated JSONB blob (see RepoCashPoolLedger), so a missing id
   *  degrades to a dash rather than an `/trades/undefined` link. */
  id?: number | null;
  origin: TradeDetailSearch;
  /** Rendered before the id inside the link. Tables leave it off (the column header names the
   *  number); identity surfaces pass `TRD-`, the detail-page convention (TradeHeader, LR-613). */
  prefix?: string;
}

export const TradeIdLink: React.FC<TradeIdLinkProps> = ({ id, origin, prefix }) => {
  if (id == null) return <span className="text-gray-400">—</span>;
  return (
    <Link
      to="/trades/$tradeId"
      params={{ tradeId: String(id) }}
      search={origin}
      className="text-blue-600 hover:text-blue-800 hover:underline"
    >
      {prefix}
      {id}
    </Link>
  );
};
